import { Reducer } from 'redux';
import { PurchaseSummary } from '../../models/purchase/summary-purchase.model';
import {
    ADD_COLLABORATOR_PURCHASE,
    ADD_COLLABORATOR_PURCHASE_ERROR,
    ADD_COLLABORATOR_PURCHASE_SUCCESS, CREATE_PURCHASE, CREATE_PURCHASE_ERROR, CREATE_PURCHASE_SUCCESS, FINISH_PURCHASE, FINISH_PURCHASE_ERROR, FINISH_PURCHASE_SUCCESS, GET_PURCHASE_SUMMARY,
    GET_PURCHASE_SUMMARY_ERROR,
    GET_PURCHASE_SUMMARY_SUCCESS,
    PAYMENT_PURCHASE,
    PAYMENT_PURCHASE_ERROR,
    PAYMENT_PURCHASE_SUCCESS,
    RESET_PURCHASE, RESET_PURCHASE_ERROR, RESET_PURCHASE_SUCCESS, UPDATE_VALUES_PURCHASE,
    UPDATE_VALUES_PURCHASE_ERROR,
    UPDATE_VALUES_PURCHASE_SUCCESS
} from '../contants';

type PurchaseInitStateType = {
  purchase: number;
  summary: object | PurchaseSummary;
  response: boolean;
  paymentSuccess: boolean;
  loading: boolean;
  paymentLoading: boolean;
  summaryLoading: boolean;
  error: boolean;
  errorMessage: string;
}

const INIT_STATE = {
  purchase: null,
  summary: {},
  response: false,
  paymentSuccess: false,
  loading: false,
  paymentLoading: false,
  summaryLoading: true,
  error: false,
  errorMessage: '',
  errorUpdate: true,
  errorUpdateMessage: '',
};

const PurchaseReducer: Reducer<PurchaseInitStateType> = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case RESET_PURCHASE:
      return { ...state, loading: true, error: false };
    case RESET_PURCHASE_SUCCESS:
      return {
        ...state,
        purchase: null,
        loading: false,
        summary: {},
        summaryLoading: false,
        error: true,
      }
    case RESET_PURCHASE_ERROR:
      return {
        ...state,
        purchase: null,
        loading: false,
        summary: {},
        summaryLoading: false,
        error: false
      }
    case CREATE_PURCHASE:
      return { ...state, loading: true, error: false };
    case CREATE_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        purchase: action.payload,
        error: false,
      };
    case CREATE_PURCHASE_ERROR:
      return {
        ...state,
        loading: false,
        purchase: null,
        error: true,
        errorMessage: action.payload.message,
      };
    case ADD_COLLABORATOR_PURCHASE:
        return { ...state, loading: true, error: false };
    case ADD_COLLABORATOR_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        error: false,
      };
    case ADD_COLLABORATOR_PURCHASE_ERROR:
      return {
        ...state,
        loading: false,
        response: false,
        error: true,
        errorMessage: action.payload.message,
      };
    case UPDATE_VALUES_PURCHASE:
      return { ...state, loading: true, errorUpdate: true };
    case UPDATE_VALUES_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        errorUpdate: false,
      };
    case UPDATE_VALUES_PURCHASE_ERROR:
      return {
        ...state,
        loading: false,
        response: false,
        errorUpdate: true,
        errorUpdateMessage: action.payload.message,
      };
    case GET_PURCHASE_SUMMARY:
      return { ...state, summaryLoading: true, error: false };
    case GET_PURCHASE_SUMMARY_SUCCESS:
      return {
        ...state,
        summaryLoading: false,
        summary: action.payload,
        error: false,
      };
    case GET_PURCHASE_SUMMARY_ERROR:
      return {
        ...state,
        summaryLoading: false,
        error: true,
        errorMessage: action.payload.message,
      };
    case PAYMENT_PURCHASE:
        return { ...state, paymentLoading: true, error: false };
    case PAYMENT_PURCHASE_SUCCESS:
        return {
          ...state,
          paymentLoading: false,
          purchase: action.payload,
          paymentSuccess: true,
          error: false,
        };
    case PAYMENT_PURCHASE_ERROR:
        return {
          ...state,
          paymentLoading: false,
          paymentSuccess: false,
          error: true,
          errorMessage: action.payload.message,
        };
    case FINISH_PURCHASE:
        return { ...state, loading: true, error: false };
    case FINISH_PURCHASE_SUCCESS:
        return {
          ...state,
          loading: false,
          purchase: action.payload,
          error: false,
        };
    case FINISH_PURCHASE_ERROR:
        return {
          ...state,
          loading: false,
          error: true,
          errorMessage: action.payload.message,
        };
    default:
      return { ...state };
  }
};

export default PurchaseReducer;
